import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({ selector: '[numeric]' })
export class NumericDirective {
  private specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Control'];
  private specialActionKeys = ['A', 'C', 'V', 'X', 'a', 'c', 'v', 'x'];
  @Input('decimals') decimals: number = 10;
  private check(value: string, decimals: number) {
    if (decimals <= 0) {
      return String(value).match(new RegExp(/^\d+$/));
    } else {
      const regExpString = '^\\s*((\\d+(\\.\\d{0,' + decimals + '})?)|((\\d*(\\.\\d{1,' + decimals + '}))))\\s*$';
      return String(value).match(new RegExp(regExpString));
    }
  }
  constructor(private el: ElementRef) {}
  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent) {
    if (
      this.specialKeys.indexOf(e.key) !== -1 ||
      (this.specialActionKeys.indexOf(e.key) !== -1 && e.ctrlKey === true) ||
      (this.specialActionKeys.indexOf(e.key) !== -1 && e.metaKey === true)
    ) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(e.key);
    if (next && !this.check(next, this.decimals)) {
      e.preventDefault();
    }
  }
}
